import { render, staticRenderFns } from "./RefusalField.vue?vue&type=template&id=2f5e616b&scoped=true"
import script from "./RefusalField.vue?vue&type=script&lang=js"
export * from "./RefusalField.vue?vue&type=script&lang=js"
import style0 from "./RefusalField.vue?vue&type=style&index=0&id=2f5e616b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5e616b",
  null
  
)

export default component.exports